import React, { type ReactElement } from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import styles from './ToolPanel.module.css';
import type AssistantViewController from '../AssistantView/AssistantViewController';
import classnames from 'classnames';
import HistoryPanel from '../HistoryPanel/HistoryPanel';

// The tool panel floats over the assistant, or to the left, and contains
// other tools like history or settings configuration.
const ToolPanel: React.FC<{}> = () => {
  const controller = useController<AssistantViewController>();
  const { currentToolPanel, size } = controller.state;
  const full = ['full-screen', 'full-page'].includes(size);
  let content: ReactElement | null = null;

  switch (currentToolPanel) {
    case 'history':
      content = <HistoryPanel />;
      break;
  }

  return (
    <div
      className={classnames(styles.toolPanel, {
        [styles.floating]: !full,
        [styles.fullScreen]: full,
        [styles.hidden]: !currentToolPanel,
      })}
    >
      {content}
    </div>
  );
};

export default ApplicationView(ToolPanel);
